import {
	getController,
	apiService as Service,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'messages'

export const messageService = {
	...getController<Api.Message, Api.MessagePostInput, Api.MessageUpdateInput>(
		url
	),
	update: (id: number, data: HpRequestPostPut<Api.MessagePostInput>) =>
		Service.put<Api.MessagePostInput>({
			url: `${url}/${id}`,
			...data,
		}),
}

export default messageService
